import React from "react";
import { PlusOrMinus, PlusOrMinusPerUnit, RawPrice } from "@vp/vp-tokenized-fragment";
export const SecondaryPlusOrMinusFullPrices = ({ choice, locale, currency, fractionDigits, pricePlaceholder, vatInc = false, hideVatMessage = true, }) => {
    const { differentialListPrice, differentialDiscountPrice } = choice;
    const discountedPrice = differentialDiscountPrice ?? differentialListPrice;
    // If both the list and discounted price are zero, then we just want to show "+$0.00".
    // The "+" is added through the zero-price CSS class.
    if (discountedPrice === 0 && differentialListPrice === 0) {
        return (React.createElement("span", { className: "zero-price" },
            "+",
            React.createElement(RawPrice, { placeHolderText: pricePlaceholder, pricingInfo: {
                    currency,
                    minimumFractionDigits: fractionDigits,
                    culture: locale,
                    listPrice: 0,
                    discountPrice: 0,
                    vatInc,
                    hideVatMessage,
                } })));
    }
    // If we want to prevent the "Base Price" text from appearing, and the list price is zero but the discounted price is not,
    // then we can take advantage of a feature of PlusOrMinusPerUnit where it hides the "Base Price" cross out, just showing the
    // discount. But in that case it also hides the "/ea" label.
    const PricingComponent = differentialListPrice === 0 && discountedPrice !== 0 ? PlusOrMinusPerUnit : PlusOrMinus;
    return (React.createElement(PricingComponent, { placeHolderText: pricePlaceholder, pricingInfo: {
            currency,
            minimumFractionDigits: fractionDigits,
            culture: locale,
            priceDifference: differentialListPrice ?? 0, // should this be default to 0
            priceDifferenceDiscounted: discountedPrice ?? 0, // should this be default to 0
        } }));
};
//# sourceMappingURL=secondary-plus-or-minus-full-prices.js.map